import React from 'react';

import { useAppSelector } from '../../components/hooks';
import { getActiveComponentDesign } from '../../store/selectors/getActiveComponentDesignSelector';
import { AnalogJointVisual } from './AnalogJointVisual';
import { AnalogLinkVisual } from './AnalogLinkVisual';
import { AnalogPanelVisual } from './AnalogPanelVisual';

export function AnalogModelVisual() {
  const analogModel = useAppSelector(getActiveComponentDesign)?.analogModel;
  const showAnalogModel = useAppSelector((state) => state.visualOptions.showAnalogModel);
  if (!showAnalogModel || !analogModel) return null;
  const joints = analogModel.analogJoints
    .filter(({ analogModelGuid }) => analogModelGuid === analogModel.guid)
    .map((analogJoint) => <AnalogJointVisual key={analogJoint.guid} analogJoint={analogJoint} />);
  const links = analogModel.analogLinks
    .filter((analogLink) => analogLink.analogModelGuid === analogModel.guid)
    .map((analogLink) => <AnalogLinkVisual key={analogLink.guid} analogLink={analogLink} />);
  const panels = analogModel.panels
    .filter(({ analogModelGuid }) => analogModelGuid === analogModel.guid)
    .map((analogPanel) => <AnalogPanelVisual key={analogPanel.guid} analogPanel={analogPanel} />);
  return (
    <>
      {joints}
      {links}
      {panels}
    </>
  );
}
